import React from "react";
import styles from "./AiBetaBadge.module.scss";

export default function AiBetaBadge() {
  return (
    <span className={styles.badge} title="AI transcription is in beta.">
      Beta
    </span>
  );
}
